module.exports = __webpack_public_path__ + "static/media/clients.4f8fb762.svg";